module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"number":"Nummer","search":"Suche","learningTenants":"Mandanten","title":"Bezeichnung","sort":"Sortierung"},"en":{"number":"Number","search":"Search","learningTenants":"Tenants","title":"Title","sort":"Sort"}}')
  delete Component.options._Ctor
}
